import { Component, OnInit, Input } from '@angular/core';
import { HomepageService } from '../../../services/homepage.service';

@Component({
  selector: 'app-quick-qa',
  templateUrl: './quick-qa.component.html',
  styleUrls: ['./quick-qa.component.css']
})
export class QuickQaComponent implements OnInit {
  widgetsSetting: any = [];
	ClassWdt: string = 'col-lg-7';

  constructor(private homepageService: HomepageService) { }
  @Input() buId: number;
  ngOnInit() {
  	this.getwidgetsSetting();
  }

  getwidgetsSetting() {
  	 let getwidgetsSettingDataSave =  this.homepageService.getwidgetsSettingDataSave();
     getwidgetsSettingDataSave.data.forEach(evt => {
            if(evt.code == 'QA' && this.buId  == evt.id){
              this.widgetsSetting = evt.settings;            
              if(!this.widgetsSetting.img){
                this.ClassWdt = 'col-lg-12';
              }
            }            
          }); 
    }

    hideAccordian(event){
      if(!$(event.target).next('.collapse').hasClass('show')){
        $('.accordion').find('.card-body').removeClass('show');      
        $('.accordion').find('.card-header').addClass('collapsed');      
      }
    }

}
